import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IDealerInformationVDF } from '../models/model'

export class AddDealerInformationApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/addDealerInformationVDF',
      requesterInfo,
    })
  }

  public async addDealerInformation(dealerInfo: IDealerInformationVDF): Promise<any> {
    return await this.postAsync<any>(dealerInfo)
  }
}
